<template>
  <div>
    <DialogPrime
      :header="$t('addMainEngineEnergySavingsComponentHeader')"
      v-model:visible="displayBasic"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <div class="formgrid grid">
        <div class="field col-12 md:col-4">
          <p>{{ $t("energyEfficiency") }}</p>
          <DropdownPrime
            id="type"
            v-model="type"
            :options="measureTypeOptions"
            optionLabel="name"
            placeholder="Energy efficiency technologies"
            class="field col-12"
          ></DropdownPrime>
        </div>
        <div v-if="type && type.code === 'WAPS'" class="field col-12 md:col-4">
          <label for="feffpeff">{{ $t("feffpeff") }} - feff·Peff (kW)</label>
          <InputTextPrime
            id="feffpeff"
            v-model="feffpeff"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div v-if="type && type.code === 'ALS'" class="field col-12 md:col-4">
          <label for="ppeffal">{{ $t("feffpeff") }} - PPeffAL (kW)</label>
          <InputTextPrime
            id="ppeffal"
            v-model="ppeffal"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div v-if="type && type.code === 'ALS'" class="field col-12 md:col-4">
          <label for="paeeffal">{{ $t("paeeffal") }} - PAEeffAL (kW)</label>
          <InputTextPrime
            id="paeeffal"
            v-model="paeeffal"
            class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
      </div>
      <template #footer>
        <ButtonPrime :label="$t('cancel')" icon="pi pi-times" @click="closeBasic" class="p-button-text" />
        <ButtonPrime :label="$t('confirm')" icon="pi pi-check" @click="saveAndClose" autofocus />
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import store from "@/store/index";
import ShipPartService from "@/services/ShipPartService";
import ParametricTableService from "@/services/ParametricTableService";
import utils from "@/utils/configuration/config.js";

export default {
  name: "AddMainEngineEnergySavingsComponent",
  data: () => {
    return {
      displayBasic: false,
      id: "",
      type: "",
      measureTypeOptions: [],
      feffpeff: 0,
      ppeffal: 0,
      paeeffal: 0,
    };
  },
  props: {
    editElementId: Object,
  },

  watch: {
    editElementId: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
      this.id = newVal.id;
      this.feffpeff = newVal.feffpeff;
      this.ppeffal = newVal.ppeffal;
      this.paeeffal = newVal.paeeffal;

      this.type = this.findElementInOptions(newVal.type, this.measureTypeOptions);

      this.displayBasic = true;
    },
  },

  created() {
    ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
  },
  mounted() {
    console.log(
      "Parametric",
      ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion)
    );
    this.measureTypeOptions = ParametricTableService.getInstance().getParametricTable(
      utils.config.firebaseConfig.parametricVersion
    ).mainEngineEnergyEfficiencyMeasureType;
  },
  methods: {
    closeBasic() {
      this.displayBasic = false;
    },
    saveAndClose() {
      console.log("AddShipPartComponent-saveAndClose", this.name);
      const newPart = {
        id: this.id,
        type: this.type.code,
        feffpeff: this.feffpeff ? this.feffpeff : 0,
        ppeffal: this.ppeffal ? this.ppeffal : 0,
        paeeffal: this.paeeffal ? this.paeeffal : 0,
      };

      const errors = ShipPartService.getInstance().saveMainEngineEnergySavingsPart(
        store.getters.currentShip,
        store.getters.currentConfiguration,
        newPart
      );

      if (errors === "") {
        this.displayBasic = false;
        this.$emit(
          "savedElement",
          "Innovative main engine mechanical energy efficiency technologies",
          !this.id || this.id === ""
        );
      } else {
        this.$emit("errorSavingElement", "Innovative main engine mechanical energy efficiency technologies", errors);
      }
    },
    editConfig() {
      console.log("editConfig");
      this.displayBasic = true;
    },
    findElementInOptions(code, options) {
      var result = {};
      options.forEach((option) => {
        if (option.code === code) {
          result = option;
        }
      });
      return result;
    },
  },
};
</script>

<style scoped>
.p-button {
  margin: 10px !important;
}
.field {
  margin-bottom: 15px !important;
}
</style>
